import { render, staticRenderFns } from "./orders-delivered.vue?vue&type=template&id=76c4b0a8&"
import script from "./orders-delivered.vue?vue&type=script&lang=js&"
export * from "./orders-delivered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports